// removed by extract-text-webpack-plugin
module.exports = {"root":"content__root","featuredShows":"content__featuredShows","letterNav":"content__letterNav"};


//////////////////
// WEBPACK FOOTER
// ./src/show-index/containers/content/styles.less
// module id = 480
// module chunks = 3